import styled from 'styled-components';

export const ReaderContainer = styled.div`
    display: flex;
    height: 100vh;
    width: 100vw;
    position: absolute;
    right: 0px;
    top: 0px;
    z-index: 10000;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;
  position: relative;
  padding: 3%;

  .pg-viewer-wrapper {
    width: 100%;
    height: 100%;
    z-index: 1;
    overflow: auto;
  }
`;

export const Overlay = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #666;
    opacity: 0.8;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 0;
`;

export const CloseButton = styled.button`
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: transparent;
    border: none;
    color: white;
    font-size: 20px;
    cursor: pointer;
    z-index: 2;
`;
